import React from "react";

export default function CropMarks() {
  return (
    <>
      <div className="crop crop-tl" aria-hidden="true" />
      <div className="crop crop-tr" aria-hidden="true" />
      <div className="crop crop-bl" aria-hidden="true" />
      <div className="crop crop-br" aria-hidden="true" />
    </>
  );
}
